export default "/_next/static/videos/tasma-group-404.mp4";